import { render, staticRenderFns } from "./standcostapplyview.vue?vue&type=template&id=8877d6a8&scoped=true&"
import script from "./standcostapplyview.vue?vue&type=script&lang=js&"
export * from "./standcostapplyview.vue?vue&type=script&lang=js&"
import style0 from "./standcostapplyview.vue?vue&type=style&index=0&id=8877d6a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8877d6a8",
  null
  
)

export default component.exports